import classNames from 'classnames';
import Image, {
  Props as ImagesProps
} from '../../Atoms/Image';

interface Props {
  images: ImagesProps[];
  className?: string;
}

function LogoList({ images, className }: Props) {
  return (
    <div
      className={classNames([
        'flex max-w-full flex-row flex-wrap items-center justify-start gap-5 lg:gap-x-12',
        className
      ])}
    >
      {images.map((image) => (
        <Image
          key={images.indexOf(image)}
          {...image}
          className="max-w-[80px] lg:max-w-full"
        />
      ))}
    </div>
  );
}

export default LogoList;
